import { getCaxaPort } from "./getCaxaPort.js";
async function getCaxaWebSocket() {
  if (!window.globalWebSocket) {
    const port = getCaxaPort();
    const webSocketUrl = `ws://127.0.0.1:${port}`;
    const webSocket = new WebSocket(webSocketUrl);
    window.globalWebSocket = {
      webSocket,
      webSocketPromise: new Promise((resolve) => {
        webSocket.addEventListener("error", () => {
          throw new Error(`webSocket\u94FE\u63A5\u5931\u8D25\u3002webSocket url\uFF1A${webSocketUrl}\u3002`);
        });
        webSocket.addEventListener("open", () => {
          resolve(webSocket);
        });
        webSocket.addEventListener("close", () => {
          window.globalWebSocket = void 0;
        });
      })
    };
  }
  return await window.globalWebSocket.webSocketPromise;
}
function getMessageFactoryV2(arg) {
  const { code } = arg;
  const fun = (sendParam, sequenceId, socketNext) => {
    const responseList = [];
    return new Promise((resolve, reject) => {
      getCaxaWebSocket().then((webSocket) => {
        function message(e) {
          const data = JSON.parse(e.data);
          if (data.sequenceId === sequenceId && (data.code === code || code.includes(data.code))) {
            if (!data.status) {
              reject(`\u6307\u4EE4${code}\u8FD4\u56DE\u9519\u8BEF\u4FE1\u606F\u3002message\uFF1A${data.message}`);
              webSocket.removeEventListener("message", message);
            } else {
              if (socketNext) {
                responseList.push(e);
                if (socketNext(responseList)) {
                  resolve(responseList);
                  webSocket.removeEventListener("message", message);
                }
              } else {
                const result = data.data ? data.data : { status: true };
                resolve(result);
                webSocket.removeEventListener("message", message);
              }
            }
          }
        }
        webSocket.addEventListener("message", message);
        webSocket.send(JSON.stringify({
          code,
          sequenceId,
          param: sendParam
        }));
      });
    });
  };
  return fun;
}
export { getCaxaWebSocket, getMessageFactoryV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/getCaxaWebSocketV2.js